import { Stack } from "@mui/material";
import React, { FC } from "react";
import { ProfileApprovalStatusEnum } from "@sinch/core/entities/serverEnums";
import { StaffHeaderFragment } from "./fragments.types";
import { Pill } from "@sinch/components/Pill/Pill";
import { useUserStatus } from "@sinch/components/application/Worker/useUserStatus";
import { useProfileApprovalStatus } from "@sinch/components/application/Worker/useProfileApprovalStatus";

/**
 * Row of status indicators for a worker: role status plus penalty / conditional
 * penalty / unapproved badges. The row hides itself when it would be empty.
 */
export const StaffVerificationStatusChips: FC<{ staff: StaffHeaderFragment }> = ({ staff }) => {
  const { getUserStatusLabel, getUserStatusColor } = useUserStatus();
  const { getProfileApprovalStatusColor, getProfileApprovalStatusLabel } = useProfileApprovalStatus();

  if (!staff.status && !staff.workerinfo?.profileApprovalStatus) {
    return null;
  }
  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={{ "&:empty": { display: "none" } }}>
      {staff.status && (
        <Pill
          label={getUserStatusLabel(staff.status)}
          size="tiny"
          sx={{ backgroundColor: getUserStatusColor(staff.status) }}
          variant="filled"
        ></Pill>
      )}
      {staff.workerinfo?.profileApprovalStatus && (
        <Pill
          label={getProfileApprovalStatusLabel(staff.workerinfo?.profileApprovalStatus as ProfileApprovalStatusEnum)}
          size="tiny"
          sx={{
            backgroundColor: getProfileApprovalStatusColor(
              staff.workerinfo?.profileApprovalStatus as ProfileApprovalStatusEnum
            ),
          }}
          variant="filled"
        ></Pill>
      )}
    </Stack>
  );
};
